import api from '@/services/Api'

// ----------------------------- o

const namespaced = false;

// ----------------------------- o

const state = {
    phone_number: '',
    hash: '',
    errors: {},
    loading: false
};

// ----------------------------- o

const getters = {

};

// ----------------------------- o

const actions = {
    'PHONE_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('PHONE_REQUEST');
            api({url: '/register/phone/verify', data: form, method: 'POST'})
                .then(resp => {
                    commit('PHONE_SUCCESS', resp.data.data);
                    resolve(resp)
                })
                .catch(err => {
                    commit('PHONE_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'TOKEN_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('TOKEN_REQUEST');
            api({url: '/register/token/verify', data: form, method: 'POST'})
                .then(resp => {
                    let token = 'Bearer '+resp.data.data.access_token
                    // set temporary api headers with "register token"
                    api.defaults.headers['Authorization'] = token;
                    commit('REGISTER_SUCCESS');
                    resolve(resp)
                })
                .catch(err => {
                    commit('TOKEN_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
    'DETAILS_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('DETAILS_REQUEST');
            api({url: '/register/details', data: form, method: 'POST'})
                .then(resp => {
                    let token = 'Bearer '+resp.data.data.access_token
                    // set local storage
                    localStorage.setItem('access_token', token);
                    // set api headers
                    api.defaults.headers['Authorization'] = token;
                    // set authenticate state
                    commit('AUTH_LOGIN_SUCCESS', token);
                    // get user profile
                    dispatch('profile/PROFILE_REQUEST').then(() => {
                        // resolve register request only if profile resolves too!
                        commit('REGISTER_SUCCESS');
                        resolve(resp)
                    });

                })
                .catch(err => {
                    commit('DETAILS_ERROR', err.response.data.errors ? err.response.data.errors : []);
                    reject(err)
                })
        })
    },
};

// ----------------------------- o

const mutations = {
    // STEP 1
    'PHONE_REQUEST': (state) => {
        state.errors = {};
        state.loading = true
    },
    'PHONE_SUCCESS': (state, resp) => {
        state.hash = resp.hash
        state.phone_number = resp.phone_number
        state.loading = false
    },
    'PHONE_ERROR': (state, resp) => {
        state.errors = resp
        state.loading = false
    },
    // STEP 2
    'TOKEN_REQUEST': (state) => {
        state.errors = {};
        state.loading = true
    },
    'TOKEN_ERROR': (state, resp) => {
        state.errors = resp
        state.loading = false
    },
    // STEP 3
    'DETAILS_REQUEST': (state) => {
        state.errors = {};
        state.loading = true
    },
    'DETAILS_ERROR': (state, resp) => {
        state.errors = resp
        state.loading = false
    },
    'REGISTER_SUCCESS': (state, resp) => {
        state.loading = false
    },
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
